const DEFAULT_CTA_URL = "https://www.risingpixel.com/";
const APPROVED_CTA_HOSTS = new Set(["risingpixel.com", "www.risingpixel.com"]);

export function resolvedCtaUrl(raw = import.meta.env.VITE_CTA_URL as string | undefined): string {
  try {
    const url = new URL(raw || DEFAULT_CTA_URL);
    return url.protocol === "https:" && APPROVED_CTA_HOSTS.has(url.hostname.toLowerCase())
      ? url.toString()
      : DEFAULT_CTA_URL;
  } catch {
    return DEFAULT_CTA_URL;
  }
}

export function openExternalCta(openWindow: typeof window.open = window.open): void {
  openWindow(resolvedCtaUrl(), "_blank", "noopener,noreferrer");
}
